import React from "react"
import {findDOMNode} from "react-dom"

import {FieldTableCellProps, FieldTableCellState, getTableCellStyle} from "../../../../../render/table/table-cell"
import PopoverPosition from "../../../../../../gd-components/gd-popover/popover-position"
import ProjectStatusSelectorPopover from "../../../../../../gd-ui/select-status/project/popover"
import {SystemStatus} from "../../../../../../gd/const/system-status"
import ProjectStatusManager from "../../../../../../gd/manager/project-status-manager"
import {isBulkSelection} from "../../../../../../gd/right-click-menu";

// const debug = "FieldProjectStatus_TableCell"
const debug = false

export default class FieldProjectStatus_TableCell extends React.Component<FieldTableCellProps, FieldTableCellState> {

    constructor(props:FieldTableCellProps) {
        super(props)

        this.state = {
            isHovered: false,
            showPopover: false
        }
    }

    get canEdit():boolean {
        if (this.props.manager.isReadOnly) return false
        return this.props.field.canEdit(this.props.listItem.item)
    }

    onMouseEnter = () => {
        if (!this.canEdit) return

        if (!this.state.isHovered) this.setState({
            isHovered   : true
        })
    }

    onMouseLeave = () => {
        if (this.state.showPopover) return

        if (this.state.isHovered) this.setState({
            isHovered   : false
        })
    }

    onValueChange = (value: ID | SystemStatus, hidePopover:boolean=true) => {
        if (this.props.listItem.project.isSystemStatusType) {
            this.props.listItem.project.updateSystemStatus(value as SystemStatus)
        } else {
            this.props.listItem.project.updateStatus(value as ID)
        }

        hidePopover && this.hidePopover()
    }

    onClick = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) return
        if (!this.canEdit) return

        this.setState({
            showPopover     : !this.state.showPopover
        })
    }

    hidePopover = () => {
        this.setState({
            showPopover     : false,
            isHovered       : false
        })
    }

    getStatus = () => {
        let res = null

        switch (this.props.listItem.project.systemType) {
            case gd.const.project.type.PROJECT      :
            case gd.const.project.type.BACKLOG      :
            case gd.const.project.type.SPRINT       :
                res = gd.session.statuses.get(this.props.listItem.project.statusId)
                break

            case gd.const.project.type.TAG          :
            case gd.const.project.type.WORKFOLDER   :
                /*don nothing*/
                break
        }

        if (!res) {
            const defaultStatuses = ProjectStatusManager.getDefaultStatuses(this.props.listItem.project.systemType)
            res =_.find(defaultStatuses, ps=>ps.id === this.props.listItem.project.systemStatus)
        }

        return res
    }

    renderValue() {
        const status = this.getStatus()
        if (!status) return false

        return (
            <div className={Classes('ui5-status-list', 'status-c{0}'.f(status.color), this.props.className)}>
                <div className="max-w-100-percent txt-truncate">{status?.name}</div>
            </div>
        )
    }

    renderHovered() {
        return (
            <div className="cell-flex is-hovered" style={getTableCellStyle(this.props)} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                <div className="ui5-field-editable size-small is-hovered w-100-percent h-100-percent" onClick={this.onClick}>
                    {this.renderValue()}

                    <div className="buttons flex-no-shrink">
                        <div className="btn-arrow"/>
                    </div>
                </div>

                {this.state.showPopover &&
                    <ProjectStatusSelectorPopover hidePopover       = {this.hidePopover}
                                                  project           = {this.props.listItem.project}
                                                  onStatusSelect    = {this.onValueChange}
                                                  togglePopover     = {this.hidePopover}
                                                  hint              = {true}
                                                  popoverPosition   = {PopoverPosition.top()}
                                                  getTarget         = {()=>findDOMNode(this)}/>}
            </div>
        )
    }

    renderNotHovered() {

        let showValue = true
        switch (this.props.listItem.project.systemType) {
            case gd.const.project.type.TAG          :
            case gd.const.project.type.WORKFOLDER   :
                showValue = false
        }

        return (
            <div className="cell-flex border-1px-transparent" style={getTableCellStyle(this.props)} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                {showValue && this.renderValue()}
            </div>
        )
    }

    render() {
        debug && console.log(debug, "render() isHovered=", this.state.isHovered)

        if (this.state.isHovered)   return this.renderHovered()
        else                        return this.renderNotHovered()
    }
}



